
































































import Vue from "vue";
import firebase from "@/plugins/firebase";

export default Vue.extend({
  name: "FileUpload",
  data: () => ({
    isImageProgress: false,
    isMp4Progress: false,
    imgSrc: "",
    mp4Src: "",
    error: {
      isError: false,
      message: "",
    },
    mp4FileName: "",
  }),
  methods: {
    clickFile() {
      this.imgSrc = "";
      this.mp4Src = "";
      this.isMp4Progress = false;
      this.isImageProgress = false;
    },
    changeFile(file: File) {
      console.log("changeFile", file);
      if ((file == null) || (file.type != "image/png") && (file.type != "image/jpeg")) {
          this.imgSrc = "";
          this.mp4Src = "";
          this.isMp4Progress = false;
          this.isImageProgress = false;
          return;
      }
      this.imgSrc = window.URL.createObjectURL(file);
      
      this.mp4FileName = file.name.replace(/(png|jpg)/, "mp4");
      console.log("mp4FileName", this.mp4FileName);
      
      // Firestore監視
      this.isMp4Progress = true;
      this.mp4Src = "";

      // アップロード処理
      this.isImageProgress = true;
      firebase.fileUpload(file,(snapshot) => {
        console.log("snapshot", snapshot);
        this.isImageProgress = false;
      });
    },
    clickMp4Url(event: any) {
      console.log("event", event.target);
      event.target.select();
    },
    onSnapshot() {
        // 初回だけ監視を実行
        firebase.onSnapshot((collection) => {
            console.log("collection", collection);
            if ((collection == null) || (collection.size == 0)) {
                return;
            }
            collection.docChanges().forEach((change) => {
                console.log("change", change);
                console.log("imgSrc", this.imgSrc);
                if ((change.type === "added") || (change.type === "modified")) {
                  if (this.imgSrc == ""){
                    return;
                  }

                  // 追加, 更新
                  const data = change.doc.data();
                  console.log("doc data", data);
                  // mp4 ダウンロードURL
                  this.mp4Src = data.mp4;

                  if (data.mp4 == "") {
                    // エラー発生時 data.mp4 が 空白
                    this.error.message = data.error;
                    this.error.isError = true;
                  }
                  this.isMp4Progress = false;
                }
            });
        });        
    },
  },
  mounted() {
      console.log("mounted this", this);
      this.onSnapshot();
  }
});
